import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

interface LeaderboardEntry {
  userId: string;
  userAlias: string;
  realName: string;
  dishName: string;
  totalTokens: number;
}

interface Props {
  roomId: string;
}

const medals = ['🥇', '🥈', '🥉'];

function RevealStage({ roomId }: Props) {
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [totalVoters, setTotalVoters] = useState(0);

  useEffect(() => {
    const load = async () => {
      const result = await api.gecGetResults(roomId);
      if (result.success) {
        setLeaderboard(result.data.leaderboard || []);
        setTotalVoters(result.data.totalVoters || 0);
      }
      setLoaded(true);
    };
    load();
  }, [roomId]);

  if (!loaded) {
    return (
      <div className="game-content gec-content">
        <div className="loading">🎉 Tallying votes…</div>
      </div>
    );
  }

  if (leaderboard.length === 0) {
    return (
      <div className="game-content gec-content">
        <div className="gec-info-box">No dishes were submitted.</div>
      </div>
    );
  }

  const top3 = leaderboard.slice(0, 3);
  const podiumOrder = [top3[1], top3[0], top3[2]].filter(Boolean); // 2nd, 1st, 3rd

  return (
    <div className="game-content gec-content">
      <h3 className="gec-section-title gec-reveal-title">🎉 Final Results 🎉</h3>
      <p className="gec-reveal-subtitle">{totalVoters} {totalVoters === 1 ? 'voter' : 'voters'} weighed in</p>

      {top3.length > 0 && (
        <div className="gec-podium">
          {podiumOrder.map((entry) => {
            const place = leaderboard.indexOf(entry) + 1;
            const heightClass = place === 1 ? 'first' : place === 2 ? 'second' : 'third';
            return (
              <div key={entry.userId} className={`gec-podium-slot ${heightClass}`}>
                <div className="gec-podium-medal">{medals[place - 1]}</div>
                <div className="gec-podium-dish">{entry.dishName}</div>
                <div className="gec-podium-chef">by {entry.realName}</div>
                <div className="gec-podium-tokens">{entry.totalTokens} 🎫</div>
                <div className={`gec-podium-bar ${heightClass}`}>{place}</div>
              </div>
            );
          })}
        </div>
      )}

      <div className="gec-leaderboard">
        <h4 className="gec-leaderboard-title">Full leaderboard</h4>
        {leaderboard.map((entry, idx) => (
          <div key={entry.userId} className={`gec-leaderboard-row ${idx < 3 ? 'top' : ''}`}>
            <div className="gec-leaderboard-rank">#{idx + 1}</div>
            <div className="gec-leaderboard-info">
              <div className="gec-leaderboard-dish">🍽️ {entry.dishName}</div>
              <div className="gec-leaderboard-chef">by {entry.realName} <span className="gec-hint">({entry.userAlias})</span></div>
            </div>
            <div className="gec-leaderboard-tokens">{entry.totalTokens} 🎫</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RevealStage;
